export default {
    CONTATO_TIPO_REPRESENTANTE_LEGAL: {
        id: "CONTATO_TIPO_REPRESENTANTE_LEGAL",
        nome: "Representante Legal",
    },
    CONTATO_TIPO_COMPRADOR: {
        id: "CONTATO_TIPO_COMPRADOR",
        nome: "Comprador",
    },
}